export type ChannelKey = 'whatsapp' | 'instagram' | 'web';

export interface ChannelMapping {
  _id: string;
  organization_id: string;
  channel: ChannelKey;
  /** `null` when this is the channel-wide default mapping. */
  phone_number_id: string | null;
  agent_config_id: string;
  is_active: boolean;
  channel_metadata?: Record<string, unknown>;
  created_at: string;
  updated_at: string;
}

export interface ChannelMappingPayload {
  agent_config_id: string;
  is_active?: boolean;
  channel_metadata?: Record<string, unknown>;
}

export type ChannelMappingErrorCode =
  | 'NOT_FOUND'
  | 'AGENT_CONFIG_NOT_FOUND'
  | 'PHONE_NUMBER_NOT_FOUND'
  | 'INVALID_CHANNEL'
  | 'VALIDATION'
  | 'UNAUTHORIZED'
  | 'UNKNOWN';

export class ChannelMappingError extends Error {
  constructor(
    public readonly code: ChannelMappingErrorCode,
    public readonly detail: string,
    public readonly status?: number,
  ) {
    super(`[${code}] ${detail}`);
    this.name = 'ChannelMappingError';
  }
}

/**
 * Stable key for per-(channel, phone) slot lookups in the slice. Pass `null`
 * for the channel-wide default mapping.
 */
export const channelSlotKey = (
  channel: ChannelKey,
  phoneNumberId: string | null,
): string =>
  phoneNumberId ? `${channel}:${phoneNumberId}` : `${channel}:_default`;
